import { PreguntaCargaDTO } from "@DTOS";
import { PreguntasTipoEnum, SingleSubtipoEnum } from "@shared/enums";
import { DatosPreguntaImportador } from "../DatosPreguntaImportador";
import { PREGUNTA_PADRE } from "../constantesImportador";
import { PreguntaImportador } from "../PreguntaImportador";

export class PreguntaResultadoImportador extends PreguntaImportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.RESULTADO;
    }

    public procesar(datos: DatosPreguntaImportador[]): PreguntaCargaDTO[] {
        const preguntas = super.procesar(datos);
        const preguntaPadre = preguntas[PREGUNTA_PADRE];
        preguntaPadre.tipo = PreguntasTipoEnum.SINGLE_CHOICE;
        preguntaPadre.subtipo = SingleSubtipoEnum.SINGLE_STATS;
        return preguntas;
    }
}
